/* eslint-disable no-unused-vars */
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import { CardApi } from '@/services/api/CardApi'
import MainMixin from '@/mixins/main'

class State {
  isCardBusy: boolean = false
  cardItems: unknown[]
  cardItem: unknown
  cardSortItems: unknown[]
  searchCardItem: string = ''
  sortItem: unknown = {}
}

// Создаем объект
const cardApi = new CardApi()

// Создаем геттеры
const getters = <GetterTree<State, any>>{
  isCardBusy(state): boolean {
    return state.isCardBusy
  },

  getCardItems(state): unknown[] {
    return state.cardItems
  },

  getCardItem(state): unknown {
    return state.cardItem
  },

  getCardSortItems(state): unknown[] {
    return state.cardSortItems
  },

  getSearchCardItem(state): string {
    return state.searchCardItem
  },

  getSortItem(state): unknown {
    return state.sortItem
  },
}

// Создаем мутации
const mutations = <MutationTree<State>>{
  setIsCardBusy(state, payload: boolean) {
    state.isCardBusy = payload
  },

  setCardItems(state, payload: unknown[]) {
    state.cardItems = payload
  },

  setCardItem(state, payload: unknown) {
    state.cardItem = payload
  },

  setCardSortItems(state, payload: unknown[]) {
    state.cardSortItems = payload
  },

  setSearchCardItem(state, payload: string) {
    state.searchCardItem = payload
  },

  setSortItem(state, payload: unknown) {
    state.sortItem = payload
  },
}

// Создаем действия
const actions = <ActionTree<State, any>>{
  // Устанавливаем элемент
  setCardItem({ commit }, data: any) {
    commit('setCardItem', data)
  },

  // Устанавливаем строку поиска
  setSearchCardItem({ commit }, data: string) {
    commit('setSearchCardItem', data)
  },

  // Устанавливаем элемент сортировки
  setSortItem({ commit }, data: any) {
    commit('setSortItem', data)
  },

  // Список элементов
  getCardItems({ commit }, data: any) {
    // Устанавливаем событие загрузки
    commit('setIsCardBusy', true)

    const filter: any =
      data !== undefined && data.filter !== undefined ? data.filter : {}
    const sort: any =
      data !== undefined && data.sort !== undefined ? data.sort : {}
    const pagination: any =
      data !== undefined && data.pagination !== undefined ? data.pagination : {}
    const isHomePage: boolean =
      data !== undefined &&
      data.isHomePage !== undefined &&
      data.isHomePage === true
        ? true
        : false
    return new Promise((resolve, reject) => {
      // Получаем список элементов
      cardApi.getCardItems(filter, sort, pagination).then(
        (response: any) => {
          const todayDate = new Date().getTime()
          // Если признак главной страницы
          if (isHomePage) {
            // Отсортированные карточки
            const sortItems: any = {
              promoted: [],
              types: [],
            }

            for (const i in response) {
              // Если существует промо изображение
              const dateFrom = new Date(
                MainMixin.methods.getFormattedDateFromTimestamp(
                  response[i].getPromotedDateFrom().getSeconds()
                )
              ).getTime()
              const dateTill = new Date(
                MainMixin.methods.getFormattedDateFromTimestamp(
                  response[i].getPromotedDateTill().getSeconds()
                )
              ).getTime()

              if (response[i].getCardPromoted()) {
                if (dateFrom <= todayDate && dateTill >= todayDate) {
                  sortItems.promoted.push(response[i])
                }
              } else {
                // Исключаем левые типы
                if (response[i].getTypeId() > 1) {
                  // Если не существует тип карточки
                  if (sortItems.types[response[i].getTypeId()] === undefined) {
                    sortItems.types[response[i].getTypeId()] = []
                  }

                  sortItems.types[response[i].getTypeId()].push(response[i])
                }
              }
            }
            commit('setCardSortItems', sortItems)
          }

          commit('setCardItems', response)
          commit('setIsCardBusy', false)
          resolve(response)
        },
        (error) => {
          commit('setIsCardBusy', false)
          reject(error)
        }
      )
    })
  },

  // Получить элемент
  getCardItem({ commit }, data: any) {
    // Устанавливаем событие загрузки

    const filter: any =
      data !== undefined && data.filter !== undefined ? data.filter : {}

    return new Promise((resolve, reject) => {
      // Получаем элемент
      cardApi.getCardItem(filter).then(
        (response: any) => {
          commit('setCardItem', response)
          commit('setIsCardBusy', false)
          resolve(response)
        },
        (error) => {
          commit('setIsCardBusy', false)
          reject(error)
        }
      )
    })
  },

  // Создать элемент
  createCardItem({ commit }, data) {
    // Устанавливаем событие загрузки
    commit('setIsCardBusy', true)

    return new Promise((resolve, reject) => {
      // Создаем элемент
      cardApi.createCardItem(data).then(
        (response) => {
          commit('setIsCardBusy', false)
          resolve(response)
        },
        (error) => {
          commit('setIsCardBusy', false)
          reject(error)
        }
      )
    })
  },

  // Обновить элемент
  updateCardItem({ commit }, data) {
    // Устанавливаем событие загрузки
    commit('setIsCardBusy', true)

    return new Promise((resolve, reject) => {
      // Обновляем элемент
      cardApi.updateCardItem(data).then(
        (response) => {
          commit('setIsCardBusy', false)
          resolve(response)
        },
        (error) => {
          commit('setIsCardBusy', false)
          reject(error)
        }
      )
    })
  },

  // Удалить элемент
  deleteCardItem({ commit }, data) {
    // Устанавливаем событие загрузки
    commit('setIsCardBusy', true)

    return new Promise((resolve, reject) => {
      // Удаляем элемент
      cardApi.deleteCardItem(data).then(
        (response) => {
          commit('setIsCardBusy', false)
          resolve(response)
        },
        (error) => {
          commit('setIsCardBusy', false)
          reject(error)
        }
      )
    })
  },
}

// Создаем модуль
const CardModule = {
  state: new State(),
  mutations: mutations,
  actions: actions,
  getters: getters,
}

export default CardModule
